export const colors = {
  green: '#1BA148',
  grey: '#F1F1F1',
  black: '#3D3D3E',
  white: '#FFFFFF',

}
